module.exports = __webpack_public_path__ + "media/politica.87f8184b.mp3";